const ApplePay = {
  key: 'applepay',
  payment_method: 'CreditCard',
}

export default ApplePay
